(() => {
  if (window.mysHalloweenInitialized) return;
  window.mysHalloweenInitialized = true;
  const controllers = new WeakMap();
  function initialize(root) {
    if (controllers.has(root)) return;
    const events = new AbortController();
    const on = (node, type, callback) => node?.addEventListener(type, callback, { signal: events.signal });
    const start = Date.parse(root.dataset.start);
    const end = Date.parse(root.dataset.end);
    let previousPhase;
    function tick() {
      const now = Date.now();
      const phase = now < start ? 'before' : now < end ? 'active' : 'ended';
      const remaining = Math.max(0, Math.ceil(((phase === 'before' ? start : end) - now) / 1000));
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      root.querySelectorAll('[data-halloween-unit]').forEach(node => { node.textContent = String(values[node.dataset.halloweenUnit]).padStart(2, '0'); });
      const clock = root.querySelector('[data-halloween-clock]');
      if (clock) clock.hidden = phase === 'ended';
      if (phase === previousPhase) return;
      root.dataset.phase = phase;
      const ready = root.dataset.campaignReady === 'true';
      const status = root.querySelector('[data-halloween-status]');
      if (status) status.textContent = phase === 'ended' ? root.dataset.statusEnded : phase === 'before' ? root.dataset.statusBefore : ready ? root.dataset.statusActive : root.dataset.statusPending;
      const label = root.querySelector('[data-halloween-countdown-label]');
      if (label) label.textContent = phase === 'ended' ? root.dataset.countdownEnded : phase === 'before' ? root.dataset.countdownBefore : root.dataset.countdownActive;
      previousPhase = phase;
    }
    tick();
    const timer = setInterval(() => { if (!root.isConnected) cleanup(); else if (!document.hidden) tick(); }, 1000);
    on(document, 'visibilitychange', () => { if (!document.hidden) tick(); });
    let unsubscribe;
    function cleanup() { clearInterval(timer); events.abort(); unsubscribe?.(); controllers.delete(root); }
    controllers.set(root, cleanup);
    if (!root.hasAttribute('data-halloween-shop')) return;
    const cards = [...root.querySelectorAll('[data-halloween-card]')];
    const filters = root.querySelector('[data-halloween-filters]');
    function filterCards(button) {
      if (!button) return;
      filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      cards.forEach(card => { card.hidden = button.dataset.halloweenFilter !== 'all' && !card.dataset.categories.includes(`|${button.dataset.halloweenFilter}|`); });
      root.querySelector('[data-halloween-empty]').hidden = cards.some(card => !card.hidden);
    }
    if (filters) {
      filterCards(filters.querySelector('[aria-pressed="true"]') || filters.querySelector('button'));
      filters.hidden = false;
      on(filters, 'click', event => filterCards(event.target.closest('[data-halloween-filter]')));
    }
    const cartUrl = root.dataset.cartUrl;
    let adding = false;
    let cartRefreshVersion = 0;
    const getDrawer = () => document.querySelector('cart-drawer');
    async function refreshCart() {
      const version = ++cartRefreshVersion;
      try {
        const response = await fetch(`${cartUrl}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (version === cartRefreshVersion && root.isConnected) root.querySelector('[data-halloween-cart-count]').textContent = cart.item_count;
      } catch (_) {}
    }
    root.querySelectorAll('[data-halloween-open-cart]').forEach(link => on(link, 'click', event => {
      const drawer = getDrawer();
      if (drawer && typeof drawer.open === 'function') { event.preventDefault(); drawer.open(link); }
    }));
    function syncCard(card, updateImage = false) {
      const select = card.querySelector('[data-halloween-variant]');
      const option = select.options[select.selectedIndex];
      const button = card.querySelector('[name="add"]');
      button.disabled = adding || option.dataset.available !== 'true';
      card.querySelector('[data-halloween-add-label]').textContent = option.dataset.available === 'true' ? root.dataset.addLabel : root.dataset.soldLabel;
      card.querySelector('[data-halloween-price]').textContent = option.dataset.price;
      const compare = card.querySelector('[data-halloween-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      const input = card.querySelector('[name="quantity"]');
      input.min = option.dataset.min;
      input.step = option.dataset.step;
      if (option.dataset.max) input.max = option.dataset.max; else input.removeAttribute('max');
      if (updateImage) {
        input.value = option.dataset.min;
        const image = card.querySelector('.mys-hw__product-image img');
        if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; image.alt = option.dataset.imageAlt; }
        card.querySelector('[data-halloween-message]').hidden = true;
      }
    }
    cards.forEach(card => {
      const form = card.querySelector('form');
      const select = card.querySelector('[data-halloween-variant]');
      on(select, 'change', () => syncCard(card, true));
      on(form, 'submit', async event => {
        event.preventDefault();
        if (adding || !form.reportValidity() || select.options[select.selectedIndex].dataset.available !== 'true') return;
        const drawer = getDrawer();
        const button = form.querySelector('[name="add"]');
        const message = form.querySelector('[data-halloween-message]');
        const id = select.value;
        const quantity = Number(form.elements.quantity.value);
        adding = true;
        cards.forEach(item => { syncCard(item); item.querySelector('[data-halloween-variant]').disabled = true; item.querySelector('[name="quantity"]').disabled = true; });
        button.querySelector('[data-halloween-add-label]').textContent = root.dataset.addingLabel;
        button.setAttribute('aria-busy', 'true');
        message.hidden = true;
        drawer?.setActiveElement(button);
        let confirmed = false;
        let addedCart;
        const endGiftMutation = window.MysHalloweenAutoGift?.beginMutation();
        try {
          const payload = { items: [{ id, quantity }] };
          if (drawer) { payload.sections = drawer.getSectionsToRender().map(section => section.id); payload.sections_url = window.location.pathname; }
          const response = await fetch(root.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          const result = await response.json();
          if (!response.ok || result.status) { message.textContent = typeof result.description === 'string' ? result.description : root.dataset.errorLabel; message.hidden = false; return; }
          confirmed = true;
          addedCart = result;
          message.textContent = root.dataset.addedLabel;
          message.hidden = false;
          if (drawer && drawer.getSectionsToRender().every(section => result.sections?.[section.id])) { drawer.classList.remove('is-empty'); drawer.renderContents(result); }
          else if (drawer) {
            const sectionIds = drawer.getSectionsToRender().map(section => section.id);
            const sectionResponse = await fetch(`${cartUrl}?sections=${sectionIds.join(',')}`, { credentials: 'same-origin' });
            if (!sectionResponse.ok) throw new Error('Cart section response failed');
            const sections = await sectionResponse.json();
            if (!sectionIds.every(id => sections[id])) throw new Error('Cart section unavailable');
            drawer.classList.remove('is-empty');
            drawer.renderContents({ ...result, sections });
          }
        } catch (_) {
          message.textContent = confirmed ? root.dataset.addedLabel : root.dataset.errorLabel;
          const link = document.createElement('a');
          link.href = cartUrl;
          link.textContent = ` ${root.querySelector('[data-halloween-open-cart]').textContent.trim()}`;
          message.append(link);
          message.hidden = false;
        } finally {
          endGiftMutation?.();
          adding = false;
          cards.forEach(item => { item.querySelector('[data-halloween-variant]').disabled = false; item.querySelector('[name="quantity"]').disabled = false; syncCard(item); });
          button.removeAttribute('aria-busy');
          if (confirmed && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mys-halloween-sale', cartData: addedCart });
          refreshCart();
        }
      });
      syncCard(card);
    });
    unsubscribe = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' ? subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart) : null;
    on(window, 'pageshow', refreshCart);
    refreshCart();
  }
  function start() { document.querySelectorAll('[data-halloween-campaign]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-halloween-campaign]').forEach(root => controllers.get(root)?.()));
})();
